import React from "react";

// Min/Max stock-amount filter menu — same interaction pattern (and CSS
// classes) as DimensionsMenu, but a single "Amount" row. Applies as
// { stockMin, stockMax } via onApply; empty inputs apply as {}.
class StockAmountMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialValues(props.values);
    }

    getInitialValues(values) {
        return {
            stockMin: (values && values.stockMin != null) ? String(values.stockMin) : "",
            stockMax: (values && values.stockMax != null) ? String(values.stockMax) : ""
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.values !== this.props.values) {
            this.setState(this.getInitialValues(this.props.values));
        }
    }

    handleChange = (field, value) => {
        // Allow only numbers and decimal points
        var cleaned = value.replace(/[^0-9.]/g, "");
        this.setState({ [field]: cleaned });
    };

    handleSubmit = () => {
        var vals = {};
        var hasValue = false;
        if (this.state.stockMin !== "") {
            vals.stockMin = parseFloat(this.state.stockMin);
            hasValue = true;
        }
        if (this.state.stockMax !== "") {
            vals.stockMax = parseFloat(this.state.stockMax);
            hasValue = true;
        }
        if (typeof this.props.onApply === "function") {
            this.props.onApply(hasValue ? vals : {});
        }
        if (typeof this.props.close === "function") {
            this.props.close();
        }
    };

    render() {
        return (
            <div className="ff-dimensions-menu">
                <div className="ff-dimensions-row">
                    <span className="ff-dimensions-label">Amount</span>
                    <input
                        type="text"
                        className="ff-dimensions-input"
                        placeholder="Min"
                        value={this.state.stockMin}
                        onChange={(e) => this.handleChange("stockMin", e.target.value)}
                    />
                    <span className="ff-dimensions-separator">&ndash;</span>
                    <input
                        type="text"
                        className="ff-dimensions-input"
                        placeholder="Max"
                        value={this.state.stockMax}
                        onChange={(e) => this.handleChange("stockMax", e.target.value)}
                    />
                </div>
                <button
                    type="button"
                    className="ff-dimensions-submit"
                    onClick={this.handleSubmit}
                >
                    Search By Amount
                </button>
            </div>
        );
    }
}

export default StockAmountMenu;
